import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  content: {
    width: '100%'
  },
  addButton: {
    paddingLeft: theme.spacing(2)
  },
  button: {
    minWidth: 0,
    width: 40,
    padding: theme.spacing(1.5)
  }
}))

export {
  useStyles
}
